import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { WhitelabelImageWebComponent } from '@resident-nx/web/ui';
import { WhitelabelImage, WhitelabelImageAltTag } from '@resident-nx/shared';

@Component({
  standalone: true,
  selector: 'rs-web-error-screen',
  imports: [TranslateModule, WhitelabelImageWebComponent],
  templateUrl: './error-screen.component.html',
  styleUrl: './error-screen.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorScreenComponent {
  public readonly WhitelabelImage = WhitelabelImage;
  public readonly WhitelabelImageAltTag = WhitelabelImageAltTag;
}
